import { ChangeDetectionStrategy, Component, Input, SimpleChanges } from '@angular/core';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { filterMediaByLabel } from '@df/ui/common/filter-media-by-label-pipe';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { Nexus } from '@tomandco/nexus-api-types';
import { SliderArrowsComponent } from 'projects/app-default/src/app/ui/slider/arrows/slider-arrows.component';
import { SwiperModule } from 'swiper/angular';
// import SwiperCore, { Navigation, Scrollbar } from 'swiper';
// SwiperCore.use([Scrollbar, Navigation]);

export const productHighlightsLabel = 'highlights';

@Component({
    selector: 'product-highlights',
    templateUrl: './product-highlights.html',
    styleUrls: ['./product-highlights.scss'],
    standalone: true,
    imports: [ImageModule, SwiperModule, SizeClassDirective, SliderArrowsComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductHighlightsComponent extends UiComponent {
    /**
     * Source product with media
     */
    @Input()
    source: Product<IProductDataV3>;

    /**
     * Images to display
     */
    protected media: Nexus.Lib.Catalog.Type.IProductMediaItem[];

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['source']) {
            this.updateMedia();
        }
        super.ngOnChanges(changes);
    }

    private updateMedia(): void {
        this.media = filterMediaByLabel(this.source.data.media || [], productHighlightsLabel, false);
    }

    get pcSlides() {
        return this.client.sizeId < 2 ? 1.2 : 3.01;
    }

    get pcSlidesCeil() {
        return Math.ceil(this.pcSlides);
    }

    get pcGutter() {
        return '10px';
    }
}
